import { MODE } from './constants';
const DEFAULT_CROSS_ORIGIN = undefined;
const DEFAULT_MANIFEST = {
  publicPath: '/',
  assets: {}
};
const DEFAULT_MODE = MODE.HYDRATE;
const DEFAULT_RETRY = 2;
const config = {
  crossOrigin: DEFAULT_CROSS_ORIGIN,
  manifest: DEFAULT_MANIFEST,
  mode: DEFAULT_MODE,
  retry: DEFAULT_RETRY
};
export { MODE };
export const getConfig = () => config;
export const setConfig = nextConfig => {
  var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
  config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : DEFAULT_CROSS_ORIGIN;
  config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : DEFAULT_MANIFEST;
  config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : DEFAULT_MODE;
  config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : DEFAULT_RETRY;
};